import {
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  TemplateRef
} from "@angular/core";
import { Nullable } from "src/app/support/nullable";
import { PageCardItemActionComponent } from "./page-card-item-action.component";
import { PageCardItemContentComponent } from "./page-card-item-content.component";
import { PageCardItemLineComponent } from "./page-card-item-line.component";

@Component({
  selector: "page-card-item",
  template: "",
  standalone: false
})
export class PageCardItemComponent {
  @ContentChildren(PageCardItemLineComponent)
  lines!: QueryList<PageCardItemLineComponent>;

  @ContentChildren(PageCardItemActionComponent)
  actions!: QueryList<PageCardItemActionComponent>;

  @ContentChild(PageCardItemContentComponent)
  content: PageCardItemContentComponent | null = null;

  @Input() avatarIcon: string | undefined;
  @Input() secondaryIcon: string | undefined;
  @Input() secondaryIconTooltip: string | TemplateRef<any> | undefined;
  @Input() actionIcon: string | undefined;
  @Input() title: string | undefined;
  @Input() status: "" | "online" | "offline" = "";
  @Input() statusLabel: string = "";
  @Input() editDisabled!: boolean;
  @Input() disableHover!: boolean;
  @Input() dragData: Nullable<any> = null;
  @Input() data: any | undefined;
  @Input() hideHeader: boolean | undefined;
  @Input() badgeText: string | undefined;

  @Output() onClick: EventEmitter<void> = new EventEmitter();
}
